import {nextTick, ref} from "vue";
import api from "@/services/api/memberApi";

class certMethod {

    //휴대폰 인증 핸들러
    handleMobileAuthClick = async (customValue, uuid = '') => {
        const hostName = window.location.hostname;
        const param = ref({
            serviceType: "web",
            deviceUuid: uuid,
            customValue: customValue,
        })

        if (hostName === 'www.silson24.or.kr' || hostName === 'silson24.or.kr') {
            param.value.svrNo = "004002"
        } else if (hostName === 'www-dr.silson24.or.kr') {
            param.value.svrNo = "003001"
        } else if (hostName === 'www.tsilson24.or.kr' || hostName === 'tsilson24.or.kr') {
            param.value.svrNo = "001002"
        } else if (hostName === 'dev.tsilson24.or.kr') {
            param.value.svrNo = "001002"
        }
        await api.getPCCInput(param.value)
            .then(res => {
                nextTick(async () => {
                    await this.openPCCWindow(res, uuid);
                })
            })
            .catch(() => {
                alert('오류가 발생했습니다.\n 관리자에게 문의해 주세요.');
            })
    }

    /**
     * 휴대폰인증 팝업 호출
     */
    openPCCWindow = (res, uuid) => {
        const formData = {
            reqInfo: res.result.reqInfo,
            retUrl: res.result.retUrl,
            verSion: '2',
            deviceUuid: uuid
        }

        const url = 'https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v2.jsp';
        const features = 'width=400, height=630, resizable=1, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200';
        const PCC_window = window.open('', 'PCCV3Window', features);

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = url;
        form.target = 'PCCV3Window'

        for (const key in formData) {
            if (formData.hasOwnProperty(key)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = formData[key];
                form.appendChild(input);
            }
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    /**
     * 아이핀 버튼클릭 이벤트
     * @returns {Promise<void>}
     */
    handleIpinAuthClick = async (customValue, uuid = '') => {
        const hostName = window.location.hostname;
        const param = ref({
            serviceType: "web",
            deviceUuid: uuid,
            customValue: customValue
        })

        if (hostName === 'www.silson24.or.kr' || hostName === 'silson24.or.kr') {
            param.value.svrNo = "013001"
        } else if (hostName === 'www-dr.silson24.or.kr') {
            param.value.svrNo = "012001"
        } else if (hostName === 'www.tsilson24.or.kr' || hostName === 'tsilson24.or.kr') {
            param.value.svrNo = "009003"
        } else if (hostName === 'dev.tsilson24.or.kr') {
            param.value.svrNo = "010003"
        }
        await api.getCBAInput(param.value)
            .then(res => {
                nextTick(async () => {
                    await this.openCBAWindow(res, uuid);
                })
            })
            .catch(() => {
                alert('오류가발생했습니다. \n 관리자에게 문의해 주세요');
            })
    }

    /**
     * 아이핀 팝업 호출 이벤트
     */
    openCBAWindow = (res, uuid) => {
        const formData = {
            reqInfo: res.result.reqInfo,
            retUrl: res.result.retUrl,
            verSion: '2',
            deviceUuid: uuid
        }

        const url = 'https://ipin.siren24.com/i-PIN/jsp/ipin_j10.jsp';
        const features = 'width=450, height=500, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200';
        const CBA_window = window.open('', 'IPINWindow', features);

        if (CBA_window === null) {
            alert(` ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는
        화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다.

        ※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.`);
        }

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = url;
        form.target = 'IPINWindow'

        for (const key in formData) {
            if (formData.hasOwnProperty(key)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = formData[key];
                form.appendChild(input);
            }
        }
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    //금융인증서 핸들러
    handleFinanceClick = (callback) => {
        var options = {};
        options.ucpidInfo = {};
        options.ucpidInfo.userAgreeInfo = {};
        options.ucpidInfo.userAgreement = "Y";
        options.ucpidInfo.userAgreeInfo.realName = true;
        options.ucpidInfo.userAgreeInfo.gender = true;
        options.ucpidInfo.userAgreeInfo.nationalInfo = true;
        options.ucpidInfo.userAgreeInfo.birthDate = true;
        options.ucpidInfo.userAgreeInfo.ci = true;
        KeySharpBiz.ucpidSign(callback, options);
    }

    //공인인증서 핸들러
    handleOfficialClick = async (callback, data = '', options = {addNonce: true}) => {
        try {
            window.KeySharpBiz.login(data, callback, options);
        } catch (err) {
            alert('공동인증서 오류가 발생했습니다.\n관리자에게 문의해 주세요.');
        }
    }

    //간편인증 핸들러
    handleSimpleClick = (callback) => {
        var json = {
            contentInfo: {
                signType: "ENT_SIMPLE_AUTH",
            },
            userInfo: {
                name: "", //이름 (ex 홍길동)
                phone1: "", //휴대폰번호 앞자리 3자리 (ex 010)
                phone2: "", //휴대폰번호 뒷자리 7,8자리 (ex 12345678)
                telcoTycd: "", //S,K,L
                ssn1: "", //주민등록번호 앞자리 (ex 900101)
                ssn2: "", //주민등록번호 뒷자리 (ex 1999999)
                birthday: "", //생년월일 (ex 19900101)
            },
            compareCI: false,
            isBirth: true,
            appPush: true,
            serviceId: "100", //기본 값
        };
        const hostName = window.location.hostname;
        let jsonPath = '';
        if (hostName === 'www.silson24.or.kr' || hostName === 'silson24.or.kr') {
            jsonPath = "/claim/web/esign/config/config.auth.json"
        } else if (hostName === 'www-dr.silson24.or.kr') {
            jsonPath = "/claim/web/esign/config/config.auth_dr.json"
        } else if (hostName === 'www.tsilson24.or.kr' || hostName === 'tsilson24.or.kr') {
            jsonPath = "/claim/web/esign/config/config.auth_t.json"
        } else if (hostName === 'dev.tsilson24.or.kr') {
            jsonPath = "/claim/web/esign/config/config.auth_dev.json"
        } else {
            jsonPath = "/claim/web/esign/config/config.auth_local.json"
        }

        setTimeout(() => {
            document.getElementById('oacxEmbededContents').focus()
        }, 300)
        // document.getElementById('wrap').setAttribute('inert', '');
        OACX.options.callback.event.close = function () {
            // document.getElementById('wrap').removeAttribute('inert');
            document.getElementById('simpleLogin').focus();
        };
        OACX.LOAD_MODULE(jsonPath, json, function (res) {
            // document.getElementById('wrap').removeAttribute('inert');
            callback(res);
        });
    }
}

export default new certMethod();